// RetirosTable.jsx
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PagoAutomaticoIcon from '@mui/icons-material/PointOfSale';
import PagoManualIcon from '@mui/icons-material/MailOutline';
import { DateTime } from 'luxon';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Collapse,
  Box,
  Typography,
  Divider,
  IconButton,
  Chip
} from '@mui/material';
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Receipt as ReceiptIcon,
  AttachMoney as AttachMoneyIcon
} from '@mui/icons-material';


const session = require('../../config/session');

class RetirosTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retiros: [],
      filaExpandida: null,
      detallesActivos: []
    };
  }

  handleExpand = (retiro, index) => {

  const yaExpandida = this.state.filaExpandida === index;

  if (yaExpandida) {
    this.setState({ filaExpandida: null, detallesActivos: [] });
  } else {
    const fechaRecaudoExacta = retiro.fecha_recaudo_datetime;

    this.props.queryDetalles(fechaRecaudoExacta, (data) => {
      this.setState({ filaExpandida: index, detallesActivos: data });
    });
  }
};

  calcularArqueo = () => {
    const arqueoMap = {
      automatico: new Map(),
      manual: 0 // solo sumaremos el total de sobres
    };

    this.state.detallesActivos.forEach((detalle) => {
      const contenido = detalle.detalle ? JSON.parse(detalle.detalle) : {};

      Object.entries(contenido).forEach(([tipo, seccion]) => {
        if (tipo === "automatico" && seccion?.currencies) {
          // Desglose de billetes automáticos
          seccion.currencies.forEach((currency) => {
            currency.bills.forEach((bill) => {
              const denom = bill.denomination;
              const cantidad = bill.amount;

              if (arqueoMap.automatico.has(denom)) {
                arqueoMap.automatico.set(denom, arqueoMap.automatico.get(denom) + cantidad);
              } else {
                arqueoMap.automatico.set(denom, cantidad);
              }
            });
          });
        }

        // Si es manual, solo sumamos el total
        if (tipo === "manual" && seccion?.currencies) {
          seccion.currencies.forEach((currency) => {
            arqueoMap.manual += currency.total_bills || 0;
          });
        }
      });
    });

    // Convertir el map de automático en array
    const arqueoAutomatico = Array.from(arqueoMap.automatico.entries())
      .sort((a, b) => b[0] - a[0])
      .map(([denominacion, cantidad]) => ({
        denominacion,
        cantidad,
        subtotal: denominacion * cantidad
      }));

    return {
      automatico: arqueoAutomatico,
      manual: arqueoMap.manual
    };
  };



  render() {
    const { filaExpandida, detallesActivos } = this.state;
    const retiros = this.props.retiros;
  
    const columns = [
      { field: "desplegable", headerName: "", width: 70 },
      { field: "fecha_recaudo_completa", headerName: 'Fecha recaudo', width: 180} ,
      { field: "codigo_cajero", headerName: 'Cajero', width: 150 },
      { field: "nombre_entidad", headerName: 'Entidad', width: 200 },
      { field: "valor_billetero", headerName: 'Total billetero', width: 140, align: 'right' },
      { field: "valor_sobre", headerName: 'Total sobre', width: 140, align: 'right' }

    ];
  
    const arqueo = this.calcularArqueo();
    /* const totalArqueo = arqueo.reduce((acc, item) => acc + item.subtotal, 0); */
  
    return (
      <Paper elevation={3} sx={{ 
        width: '100%', 
        maxWidth: 980,
        overflow: 'hidden', 
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        mb: 3
      }}>
        <TableContainer>
          <Table stickyHeader sx={{ minWidth: 750 }}>
            <TableHead>
              <TableRow sx={{
                  '& th': {
                    backgroundColor: '#8CC63E',
                    borderBottom: '2px solid #d2e8b5',
                    color: '#ffffff',
                    fontWeight: 'bold',
                    fontSize: '0.8rem',
                    py: 1.5,
                    px: 2,
                  }
                }}>
                {columns.map((column) => (
                  <TableCell
                    key={column.field}
                    sx={{
                      width: column.width,
                      textAlign: column.align || 'left',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {column.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
  
            <TableBody>
              {retiros.map((retiro, index) => {
                const estaAbierta = filaExpandida === index;
                const fechaFormateada = DateTime.fromFormat(retiro.fecha_recaudo, 'dd/MM/yyyy HH:mm:ss').toFormat('yyyy-MM-dd HH:mm:ss');
  
                return (
                  <React.Fragment key={index}>
                    <TableRow sx={{
                      '& td': { 
                        py: 1.5,
                        px: 2,
                        borderBottom: estaAbierta ? 'none' : undefined
                      },
                      '& tr:nth-of-type(odd)': { backgroundColor: '#f7fdf1' },
                      '& tr:hover': { backgroundColor: '#eaf8d7' },
                      
                    }}>
                      <TableCell>
                        <IconButton 
                          size="small" 
                          onClick={() => this.handleExpand(retiro, index)}
                          color={estaAbierta ? 'primary' : 'default'}
                        >
                          {estaAbierta ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                      </TableCell>
                      <TableCell>{retiro.fecha_recaudo_completa}</TableCell>
                      
                      <TableCell>
                        {session.checkPermiso('acceder_cajeros_resumen') ? (
                           <Link to={{ pathname: '/dashboard/cajeros/resumen', state: { id_cajero: retiro.id_cajero } }}>
                           {retiro.codigo_cajero}
                            </Link>
                          ) : (
                            <span>{retiro.codigo_cajero}</span>
                          )}                         
                        </TableCell>
                      <TableCell>{retiro.nombre_entidad}</TableCell>
                      <TableCell sx={{
                        fontWeight: 'fontWeightMedium',
                        textAlign: 'right',
                        color: 'success.main'
                      }}>
                        {Number(retiro.valor_billetero || 0).toLocaleString()}
                      </TableCell>
                      <TableCell sx={{
                        fontWeight: 'fontWeightMedium',
                        textAlign: 'right',
                        color: 'success.main'
                      }}>
                        {Number(retiro.valor_sobre || 0).toLocaleString()}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={6} sx={{
                        p: 0,
                        borderBottom: `1px solid`,
                        borderColor: 'divider'
                      }}>
                        <Collapse in={estaAbierta} timeout="auto" unmountOnExit>
                          <Box sx={{ 
                            backgroundColor: 'background.default',
                            borderLeft: 4,
                            borderColor: 'primary.main',
                            p: 3
                            }}>
                            
                            {/* Sección Arqueo */}
                            <Box mt={4}>
                             <Box display="flex" alignItems="center" mb={2}>
                                <PagoManualIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                  Informacion de sobres
                                </Typography>
                              </Box>
                              <Divider sx={{ mb: 2 }} />

                              {/* Arqueo Manual (solo total) */}
                                {arqueo.manual > 0 ?(
                                  <Box mt={2} mb={5} ml={5}>
                                    <Typography sx={{ mt: 1, fontWeight: "bold" }}>
                                      Dinero total en sobres: ${arqueo.manual.toLocaleString()}
                                    </Typography>
                                  </Box>
                                ): (
                                    <Box mt={2} mb={5} ml={5}>
                                      <Typography color="text.secondary" fontStyle="italic">
                                        No hay sobres registrados.
                                      </Typography>
                                    </Box>
                                  )}

                              <Box display="flex" alignItems="center" mb={2}>
                                <AttachMoneyIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                  Desglose de Efectivo
                                </Typography>
                              </Box>
                              <Divider sx={{ mb: 2 }} />

                              {/* Arqueo Automático */}
                              {arqueo.automatico.length > 0 && (
                                <Box mb={4}>
                                  <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                    Automático
                                  </Typography>
                                  <Table
                                    size="small"
                                    sx={{
                                      "& th": { backgroundColor: "action.selected", fontWeight: "bold" },
                                      "& td, & th": { py: 1, px: 2 },
                                    }}
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell sx={{ width: 100 }}>Denominación</TableCell>
                                        <TableCell sx={{ textAlign: "right" }}>Cantidad</TableCell>
                                        <TableCell sx={{ textAlign: "right" }}>Subtotal</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {arqueo.automatico.map((row, idx) => (
                                        <TableRow key={idx} hover>
                                          <TableCell>{row.denominacion.toLocaleString()}</TableCell>
                                          <TableCell sx={{ textAlign: "right" }}>{row.cantidad}</TableCell>
                                          <TableCell sx={{ textAlign: "right", fontWeight: "500" }}>
                                            ${row.subtotal.toLocaleString()}
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                    <TableFooter>
                                      <TableRow
                                        sx={{
                                          "& td": {
                                            fontWeight: "bold",
                                            backgroundColor: "action.selected",
                                          },
                                        }}
                                      >
                                        <TableCell>Total</TableCell>
                                        <TableCell />
                                        <TableCell sx={{ textAlign: "right" }}>
                                          $
                                          {arqueo.automatico
                                            .reduce((sum, r) => sum + r.subtotal, 0)
                                            .toLocaleString()}
                                        </TableCell>
                                      </TableRow>
                                    </TableFooter>
                                  </Table>
                                </Box>
                              )}

                            </Box>


                            {/* Sección Detalles */}
                          <Box mb={4} mt={4}>
                              <Box display="flex" alignItems="center" mb={2} sx={{ mr: 5 }} >
                                <ReceiptIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                  Detalles del deposito 
                                </Typography>
                              </Box>
                              <Divider sx={{ mb: 2 }} />
  
                              <Table size="small" sx={{ 
                                '& th': {
                                  backgroundColor: 'action.selected',
                                  fontWeight: 'fontWeightBold'
                                },
                                '& td, & th': {
                                  py: 1,
                                  px: 2
                                }
                              }}>
                                <TableHead>
                                  <TableRow>
                                    <TableCell sx={{ width: 200 }}>Fecha deposito</TableCell>
                                    <TableCell sx={{ width: 200 }}>Tipo</TableCell>
                                    <TableCell sx={{ width: 200 }}>Transaccion</TableCell>
                                    <TableCell sx={{ width: 200 }}>Depositante</TableCell>
                                    <TableCell sx={{ width: 150, textAlign: 'right' }}>Valor</TableCell>
                                    <TableCell sx={{ width: 200 }}>Aprobacion</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {detallesActivos.map((detalle, i) => (
                                    <TableRow key={i} hover>
                                      <TableCell>{detalle.fecha_dispositivo}</TableCell>
                                      <TableCell>{detalle.tipo_transaccion === 100 ? <PagoAutomaticoIcon /> : <PagoManualIcon />}</TableCell>
                                      <TableCell>{detalle.TipoTransaccion}</TableCell>
                                      <TableCell>{detalle.nombre_cliente}</TableCell>
                                      <TableCell sx={{ textAlign: 'right', fontWeight: 'fontWeightMedium' }}>
                                        {detalle.valor.toLocaleString()}
                                      </TableCell>
                                      <TableCell>
                                        <Chip 
                                          label={detalle.aprobacion} 
                                          size="small"
                                          color={detalle.aprobacion === 'Aprobado' ? 'success' : 'default'}
                                          variant="outlined"
                                        />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }
}

export default RetirosTable;
